import { useMutation } from "@apollo/client";
import { AddIcon, InfoIcon, PlusSquareIcon, StarIcon } from "@chakra-ui/icons";
import {
  Badge,
  Box,
  Button,
  Divider,
  Flex,
  Image,
  Link,
  Tooltip,
  useToast,
} from "@chakra-ui/react";
import { useContext, useState } from "react";
import { BsHeart, BsHeartFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import {
  CREATE_FAVORITE,
  DELETE_FAVORITE,
} from "../../services/graphql/mutation/Favorites";
import { IProduct } from "../../services/graphql/Product";
import { ContextApp } from "../../shared/ContextApp";
import { MessageError } from "../../shared/MessageError";
import { MessageSuccess } from "../../shared/MessageSuccess";

export interface ICardProductsProps {
  dataProduct: IProduct;
  finallyFavorite: () => void;
}
export const CardProducts = (props: ICardProductsProps) => {
  const { user } = useContext(ContextApp);
  const [createFavorite] = useMutation(CREATE_FAVORITE);
  const [deleteFavorite] = useMutation(DELETE_FAVORITE);
  const [loadingFavorite, setLoadingFavorite] = useState<boolean>(false);
  const { dataProduct, finallyFavorite } = props;
  const toast = useToast();
  const navigate = useNavigate();

  const addProductFavorites = (product_id: number) => {
    setLoadingFavorite(true);
    createFavorite({
      variables: {
        product_id,
      },
    })
      .then(() => {
        toast({
          duration: 2500,
          position: "top",
          render: () =>
            MessageSuccess({
              title: "Agregado a favoritos",
              description: "",
            }),
        });
      })
      .catch(() => {
        toast({
          duration: 2500,
          position: "top",
          render: () =>
            MessageError("No pudimos agregar el producto a favoritos"),
        });
      })
      .finally(() => {
        finallyFavorite();
        setLoadingFavorite(false);
      });
  };

  const deleteProductFavorites = (id: number) => {
    setLoadingFavorite(true);
    deleteFavorite({
      variables: {
        id,
      },
    })
      .then(() => {
        toast({
          duration: 2500,
          position: "top",
          render: () =>
            MessageSuccess({
              title: "Eliminado de favoritos",
              description: "",
            }),
        });
      })
      .catch(() => {
        toast({
          duration: 2500,
          position: "top",
          render: () =>
            MessageError("No pudimos quitar el producto de favoritos"),
        });
      })
      .finally(() => {
        finallyFavorite();
        setLoadingFavorite(false);
      });
  };

  return (
    <>
      <Box
        boxShadow="md"
        maxW="sm"
        borderWidth="1px"
        borderRadius="lg"
        overflow="hidden"
        display={"flex"}
        flexDirection="column"
      >
        {dataProduct.url_image ? (
          <div style={{ height: "225px", width: "100%" }}>
            <Image
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={dataProduct.url_image}
              alt={dataProduct.name}
            />
          </div>
        ) : null}
        <Box p="6" mt={"auto"}>
          <Box display="flex" alignItems="baseline">
            {dataProduct.shine ? (
              <Badge borderRadius="full" px="2" colorScheme="teal">
                Brilla
              </Badge>
            ) : null}
            <Box
              color="gray.500"
              fontWeight="semibold"
              letterSpacing="wide"
              fontSize="xs"
              textTransform="uppercase"
              ml="2"
            ></Box>
          </Box>
          <Box
            mt="1"
            fontWeight="semibold"
            as="h4"
            lineHeight="tight"
            isTruncated
          >
            {dataProduct.name}
          </Box>

          <Box>
            <Box as="span" color="gray.600" fontSize="sm">
              $
            </Box>
            <span>{dataProduct.price}</span>
          </Box>

          <Box display="flex" mt="2" alignItems="center">
            <InfoIcon color="teal.500" />
            <Box as="span" ml="2" color="gray.600" fontSize="sm">
              {dataProduct.description}
            </Box>
          </Box>
          <Divider my={5} />
          <Box
            display="flex"
            mt="5"
            alignItems="center"
            justifyContent={"space-between"}
          >
            <Link
              className="link-without-underline"
              href={`/product/${dataProduct.id}`}
            >
              <Button
                w="100%"
                rightIcon={<AddIcon />}
                colorScheme="blue"
                variant="outline"
              >
                Mas detalles
              </Button>
            </Link>
            {user ? (
              <>
                {dataProduct.favorite.filter(
                  (ele) => ele.product_id === dataProduct.id
                ).length ? (
                  <>
                    <Tooltip
                      label="Quitar producto de favoritos"
                      hasArrow
                      placement="top"
                    >
                      <div>
                        <BsHeartFill
                          onClick={() => {
                            deleteProductFavorites(dataProduct.favorite[0].id);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </Tooltip>
                  </>
                ) : (
                  <>
                    <Tooltip
                      label="Agregar producto a favoritos"
                      hasArrow
                      placement="top"
                    >
                      <div>
                        <BsHeart
                          onClick={() => {
                            addProductFavorites(dataProduct.id);
                          }}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </Tooltip>
                  </>
                )}
              </>
            ) : undefined}
          </Box>
        </Box>
      </Box>
    </>
  );
};
